import * as focusTrap from 'focus-trap';

const NotificationBox = {
    init() {
        const notificationBox = document.querySelector('.notification-box');
        const trap = focusTrap.createFocusTrap(notificationBox);

        if (notificationBox) {
            notificationBox.addEventListener('click', (e) => {
                if (e.target === notificationBox)  {
                   openNotification()
                }
            });

            notificationBox.addEventListener('keydown', (e) => {
                console.log('in notification box')
                if (e.target === notificationBox && (e.key === 'Enter' || e.key === ' '))  {
                    console.log('open notification box')
                    openNotification()
                    trap.activate()
                }
            });

            document.addEventListener('keydown', e => {
                if (e.key === 'Escape' && notificationBox.classList.contains('is-active')) {
                    trap.deactivate();
                    notificationBox.classList.remove('is-active');
                    notificationBox.classList.remove('is-suspended');
                    notificationBox.setAttribute('aria-expanded', 'false');
                    document.activeElement.blur()
                }
            } )

            notificationBox.querySelector('.modal-close').addEventListener('click', (e) => {
                e.stopPropagation()
                trap.deactivate()
                notificationBox.classList.remove('is-active');
                notificationBox.classList.remove('is-suspended');
                notificationBox.setAttribute('aria-expanded', 'false');
                document.activeElement.blur()
            });

            setTimeout(() => {
                notificationBox.classList.add('is-active');
                notificationBox.setAttribute('aria-expanded', 'true');
                //notificationBox.focus();
            }, 1000);

            setTimeout(() => {
                notificationBox.classList.add('is-suspended');
                notificationBox.classList.remove('is-active');
                notificationBox.setAttribute('aria-expanded', 'false');
                //document.querySelector('a').focus();
            }, 5000);

            function openNotification() {
                notificationBox.classList.add('is-active');
                notificationBox.setAttribute('aria-expanded', 'true');
            }
        }
    }
};

export default NotificationBox;
